import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StadiumEventsData } from 'teacher-ui-client/components/giraffe/charts/dashboard/stadium-events'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StadiumEventsResponse {
  stadium_events: [
    { event_type: 'spelling'; count: number },
    { event_type: 'grammar'; count: number },
    { event_type: 'vocabulary'; count: number },
    { event_type: 'usage'; count: number },
  ]
}

export async function stadiumEvents(
  this: StudentEventsService,
  product: LegacyProductRex,
  studentScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StadiumEventsData>> {
  if (isEmpty(studentScope.ids)) return null

  const url = this.buildUrl('stadium_events', product, studentScope)
  const query = this.buildQuery(studentScope, period)

  const data = await this.fetchData<StadiumEventsResponse>(url, query)
  if (!data) return null

  const { stadium_events } = data
  if (stadium_events.length !== 4) return null

  const spelling = stadium_events.find((e) => e.event_type === 'spelling')!.count
  const grammar = stadium_events.find((e) => e.event_type === 'grammar')!.count
  const vocabulary = stadium_events.find((e) => e.event_type === 'vocabulary')!.count
  const usage = stadium_events.find((e) => e.event_type === 'usage')!.count
  if (spelling === 0 && grammar === 0 && vocabulary === 0 && usage === 0) return null

  return {
    spelling,
    grammar,
    vocabulary,
    usage,
  }
}
